// Configuration for API URL
// Dev: localhost:5001. Prod VPS: VITE_API_URL (GitHub Actions).
// Prod k8s (nginx same-origin proxy): leave VITE_API_URL unset → window.location.origin
let apiUrl = import.meta.env.VITE_API_URL;

if (!apiUrl) {
    apiUrl = import.meta.env.DEV
        ? 'http://localhost:5001'
        : (typeof window !== 'undefined' ? window.location.origin : '');
}

// Ensure proper protocol prefix (skip already-absolute and empty values)
if (apiUrl && !apiUrl.startsWith('http') && !apiUrl.startsWith('/')) {
    apiUrl = `http://${apiUrl}`;
}

// Fix mixed content: if page is HTTPS, API must also be HTTPS
// BUT: In development, we usually want to keep HTTP for localhost
if (typeof window !== 'undefined' && window.location.protocol === 'https:' && apiUrl.startsWith('http:') && !apiUrl.includes('localhost')) {
    apiUrl = apiUrl.replace(/^http:/, 'https:');
}

// Log API URL in development for debugging
if (import.meta.env.DEV && typeof window !== 'undefined') {
    console.log('🔧 API_URL configurada:', apiUrl);
    console.log('🔧 Window location:', window.location.href);
    console.log('🔧 VITE_API_URL env:', import.meta.env.VITE_API_URL);
}

export const API_URL = apiUrl;
